var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarningOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3325 11.8381L10.3324 11.8381L10.3352 11.8407C10.472 11.9674 10.554 12.1678 10.554 12.3705C10.554 12.5609 10.4735 12.7625 10.3327 12.9027L10.3325 12.9029C10.1916 13.0438 10.0005 13.1244 9.80007 13.1244C9.59945 13.1244 9.4085 13.0445 9.26783 12.9031L9.26766 12.9029C9.12722 12.7625 9.04617 12.5606 9.04617 12.3705C9.04617 12.1676 9.12753 11.9674 9.26473 11.8409L9.26479 11.841L9.26766 11.8381C9.40853 11.6972 9.59955 11.6166 9.79989 11.6166C10.0007 11.6173 10.1918 11.6974 10.3325 11.8381Z",
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.554 6.77089V10.0029C10.554 10.4141 10.212 10.7568 9.80007 10.7568C9.38884 10.7568 9.04617 10.4148 9.04617 10.0029V6.77089C9.04617 6.34883 9.38728 6.01699 9.80007 6.01699C10.2121 6.01699 10.554 6.34889 10.554 6.77089Z",
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4696 14.3033H16.6428L16.5562 14.1533L9.88658 2.60094L9.79998 2.45093L9.71337 2.60094L3.04377 14.1533L2.95717 14.3033H3.13038H16.4696ZM9.1469 0.57218L9.14693 0.5722L9.14829 0.56969C9.27747 0.330464 9.52767 0.189355 9.80014 0.189355C10.0726 0.189355 10.3228 0.33046 10.452 0.56969L10.452 0.56971L10.4534 0.57218L18.6021 14.6845C18.6021 14.6846 18.6022 14.6847 18.6023 14.6849C18.7325 14.916 18.7325 15.209 18.6021 15.4401C18.4731 15.6687 18.2231 15.8104 17.9493 15.8104H1.65094C1.37791 15.8104 1.12713 15.6687 0.998191 15.4401C0.867816 15.2091 0.867742 14.9161 0.997967 14.6849C0.998042 14.6848 0.998117 14.6846 0.998191 14.6845L9.1469 0.57218Z",
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningOutline);
export default __webpack_public_path__ + "static/media/Icon-warning-outline.97f8d8c6.svg";
export { ForwardRef as ReactComponent };